import styled from 'styled-components';

export const SWrapper = styled.div`
  @media (min-width: 600px) {
    width: 50%;
  }
`;

export const SForm = styled.div`
  height: auto;
`;
